import {
    CaptchaRequirementsResponseDto,
    RecaptchaDto,
    SignUpDto,
    SignUpResultDto,
    SuggestTenantNameRequestDto,
    SuggestTenantNameResponseDto,
    TenantDto
} from './dtos';

const fetchFromUrl = <T, R>(
    url: string,
    data: T,
    method?: RequestInit['method']
): Promise<R> =>
    fetch(url, {
        method: method ?? 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(text => {
                throw new Error(text);
            });
        })
        .catch((err: string) => {
            throw new Error(err);
        });

export const signupApi = (dto: SignUpDto) =>
    fetchFromUrl<SignUpDto, SignUpResultDto>('/signup', dto);

export const checkRecaptchaApi = (dto: RecaptchaDto) =>
    fetchFromUrl<RecaptchaDto, CaptchaRequirementsResponseDto>(
        '/signup/recaptcha',
        dto,
        'PUT'
    );

export const suggestTenantNameApi = (dto: SuggestTenantNameRequestDto) =>
    fetchFromUrl<SuggestTenantNameRequestDto, SuggestTenantNameResponseDto>(
        '/signup/tenant-name/suggest',
        dto
    );

export const getGeoInfo = async (): Promise<string> => {
    const response = await fetch('https://ip2c.org/s').catch(() => '');
    return response instanceof Response ? response.text() : response;
};

export const verifyRedirectedTenantName = (): Promise<TenantDto> =>
    fetch('/signup/recently-used-tenant')
        .then(response => {
            if (response?.ok) {
                return response.json();
            }
            if (response.status === 404) {
                return {
                    tenantName: '',
                    tenantUsageType: 'EMPTY'
                };
            }
            return response.text().then(text => {
                throw new Error(text);
            });
        })
        .catch((err: string) => {
            throw new Error(err);
        });
